import WKT from '@wifikey/wkt';

// 参考文档 http://fe.51y5.net/doc-center/wkt/
/**
 * 打点
 * @param {* String} eventId 事件id
 * @param {* String, Object} params 打点参数
 */
export default function send(eventId = '', params = {}) {
  const query = params;

  if (eventId) {
    const traceV2 = {
      f: eventId,
      b: query,
    };
    WKT.send({
      data: traceV2,
    });

    console.log('【WKT】', { f: eventId, b: query });
  } else {
    console.log('【WKT】', { f: eventId, b: query });
  }
}



// WEBPACK FOOTER //
// ./src/utils/tracker.js